import React, { useState } from "react";
import CusInput from "../../../mui/custom_input/CusInput";
import IconPhone from "../../../mui/JSXIcons/IconPhone";
import CusSelect from "../../../mui/cus_select/CusSelect";
import ShowContainer from "../../../mui/ShowContainer";
import IconAddress from "../../../mui/JSXIcons/IconAddress";
import { ENUM_CURRENCY } from "../../../../store/enums";

export default function PhoneFields({ bankList, setSelectBank, curMethods, currency }) {
  const prefix = currency == ENUM_CURRENCY.ETB ? "2519" : "";
  const [phone, setPhone] = useState(prefix);
  const isMethodBank = !curMethods.length || curMethods.includes("bank");
  const isShowBankSelect = bankList && isMethodBank;

  const phonePlaceholder = currency == ENUM_CURRENCY.ETB ? "251911111111" : "+71234567890";
  const phoneRegular = currency == ENUM_CURRENCY.ETB ? "^2519[0-9]{8}$" : "";
  const maxLength = currency == ENUM_CURRENCY.ETB ? 12 : undefined;

  return (
    <>
      <CusInput
        iconJSXstart={<IconPhone />}
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        type={"tel"}
        autocomplete="tel"
        placeholder={phonePlaceholder}
        name={"phoneNumber"}
        required
        regular={phoneRegular}
        maxLength={maxLength}
      />

      <ShowContainer condition={isShowBankSelect}>
        <CusSelect
          name="bankName"
          required
          className="bank-select"
          options={bankList?.map((el) => ({ label: el, value: el }))}
          placeholder="Beneficiary bank"
          onChange={setSelectBank}
          iconJSXstart={<IconAddress />}
        />
      </ShowContainer>
    </>
  );
}
